(function () {
  if (window.innerWidth < 1000) {
    const body = document.body;
    const navigation = document.getElementById("main-navigation");
    const navbar = document.getElementById("main-navbar");
    const title = document.getElementById("main-navbar-title");
    const menu = document.getElementById("main-menu");
    const menuItems = menu?.querySelectorAll("a") || [];
    const toggles = document.querySelectorAll("[data-js-navigation-toggle]");
    const btnBack = document.getElementById("main-menu-back");
    const btnClose = document.getElementById("main-navbar-close");

    if (!navigation || !navbar || !title || !menu) return;

    let currentLevel = 1;
    let menuStack = [];
    let titleStack = [];
    let currentMenu = null;

    const showNavigation = () => {
      navigation.dataset.visible = "true";
      navigation.dataset.open = "true";
      body.classList.add("no-scroll");
      menu.dataset.open = "true";
    };

    const hideNavigation = () => {
      navigation.dataset.open = "false";
      body.classList.remove("no-scroll");
      navigation.dataset.visible = "false";
      resetMenuState();
    };

    const showSubmenu = (subMenu, clickedTitle) => {
      if (!subMenu) return;

      currentLevel++;
      menuStack.push(currentMenu);
      titleStack.push(clickedTitle);

      currentMenu?.setAttribute("data-open", "false");
      currentMenu = subMenu;
      subMenu.setAttribute("data-open", "true");
      navbar.dataset.level = currentLevel;
      navbar.dataset.submenuOpen = "true";

      updateTitle(clickedTitle);
    };

    const hideSubmenu = () => {
      if (currentLevel === 1) return;

      const previousMenu = menuStack.pop();
      const previousTitle = titleStack.length > 0 ? titleStack[titleStack.length - 2] : "";

      currentLevel--;
      titleStack.pop();

      currentMenu?.setAttribute("data-open", "false");
      if (previousMenu) {
        previousMenu.setAttribute("data-open", "true");
      }

      currentMenu = previousMenu;
      navbar.dataset.level = currentLevel;
      navbar.dataset.submenuOpen = currentLevel > 1 ? "true" : "false";

      updateTitle(previousTitle);
    };

    const updateTitle = (newTitle) => {
      title.dataset.title = newTitle || "";
    };

    const resetMenuState = () => {
      currentLevel = 1;
      menuStack = [];
      titleStack = [];
      currentMenu = null;
      navbar.dataset.level = "1";
      navbar.dataset.submenuOpen = "false";
      menu.dataset.open = "false";

      menu.querySelectorAll(".sub-menu").forEach(submenu => {
        submenu.setAttribute("data-open", "false");
      });

      updateTitle("");
    };

    btnBack?.addEventListener("click", hideSubmenu);
    btnClose?.addEventListener("click", hideNavigation);

    toggles.forEach(toggle => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        showNavigation();
      });
    });

    menuItems.forEach(item => {
      const sibling = item.nextElementSibling;
      if (sibling?.classList.contains("sub-menu")) {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          showSubmenu(sibling, e.target.innerText);
        });
      }
    });
  }
})();
